var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _path8, _line, _line2, _path9, _path10, _line3, _line4, _path11, _path12, _path13, _path14, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.572,
    height: 62.278,
    viewBox: "0 0 58.572 62.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.073,
    y1: 0.12,
    x2: 0.451,
    y2: 0.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#773427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopColor: "#c76327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.204,
    y1: 1.7,
    x2: 0.529,
    y2: 0.337,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a67c52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.033,
    y1: 0.575,
    x2: 0.511,
    y2: 0.502,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.479,
    y1: 0.234,
    x2: 0.518,
    y2: 0.59,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.918,
    y1: 0.384,
    x2: -0.269,
    y2: 0.642,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb886"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#b060f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.358,
    y1: 0.418,
    x2: 1.297,
    y2: 0.73,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: -0.108,
    x2: 0.5,
    y2: 0.655,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.495,
    y1: 1.6,
    x2: 0.502,
    y2: -0.767,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74c1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43a7b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    y1: 0.882,
    x2: 0.5,
    y2: 0.269,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b8ac7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.483,
    y1: 0.457,
    x2: -0.421,
    y2: 0.015,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.525,
    y1: 0.834,
    x2: 0.462,
    y2: 0.196,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.543,
    y1: 0.914,
    x2: 0.471,
    y2: 0.189,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -176.328,
    y1: 0.5,
    x2: -175.328,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2527",
    "data-name": "Group 2527",
    transform: "translate(-279 -511.433)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 29.286,
    cy: 29.286,
    rx: 29.286,
    ry: 29.286,
    transform: "translate(279 515.139)",
    fill: "#d2d5ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(280.743 512.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(7.013 12.099)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M426.7,568.932s-2.376-7.165,3.54-17.279a35.6,35.6,0,0,1,14.841-.511Z",
    transform: "translate(-426.23 -550.563)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M445.664,551.144l-5.011,4.848c-4.877,1.094-9.405,2.008-12.9,2.683a30.694,30.694,0,0,1,3.067-7.025A35.616,35.616,0,0,1,445.664,551.144Z",
    transform: "translate(-426.811 -550.563)",
    opacity: 0.6,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M426.7,568.932s-2.376-7.165,3.54-17.279a35.6,35.6,0,0,1,14.841-.511Z",
    transform: "translate(-426.23 -550.563)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(7.075 0)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M470.9,551.411a.766.766,0,0,1-.367.152c-2.258.425-4.8-2.992-4.941-3.189a28.181,28.181,0,0,1,1.9,13.281,27.47,27.47,0,0,1-1.036,5.331,24.454,24.454,0,0,0-.1-3.335c-.017-.186-.035-.385-.058-.588-.017-.157-.035-.32-.058-.483-.024-.193-.046-.4-.082-.6s-.058-.4-.093-.611c-.076-.437-.163-.9-.268-1.362-.035-.186-.082-.378-.128-.565,0-.011-.006-.023-.006-.029-.047-.18-.088-.36-.14-.541-.058-.215-.116-.436-.186-.663-.035-.122-.076-.25-.116-.378-.081-.279-.18-.564-.279-.85-.046-.134-.1-.268-.151-.407s-.1-.274-.157-.408-.1-.25-.151-.372a.476.476,0,0,1-.041-.1c-.111-.25-.221-.507-.349-.756-.064-.14-.128-.274-.2-.407s-.14-.274-.21-.408-.146-.268-.227-.4a17.279,17.279,0,0,0-1-1.56c-.093-.128-.186-.256-.279-.378s-.2-.25-.3-.373a.4.4,0,0,0-.035-.047q-.289-.349-.594-.681l-.332-.349c-.343-.344-.71-.681-1.094-1-.128-.1-.256-.21-.385-.308s-.273-.2-.408-.3l-.227-.157c-.111-.081-.233-.163-.349-.238-.367-.239-.756-.466-1.158-.675-.082-.047-.163-.087-.245-.128-.192-.093-.384-.186-.582-.274-.14-.07-.285-.128-.431-.186q-.28-.123-.576-.227c-.1-.041-.216-.082-.32-.116a17.557,17.557,0,0,0-2.311-.629l-.576-.1c-.216-.035-.425-.07-.646-.1l-12.8.437-.885-.832s-9.009,3.451-11.192-4.7c-.96-3.579-.145-6.093,1.432-7.676.076-.082.157-.157.239-.233l.006-.006a6.023,6.023,0,0,1,.512-.413q.192-.139.384-.262c.116-.076.239-.146.361-.209a7.265,7.265,0,0,1,1.013-.466,8.327,8.327,0,0,1,3.126-.5.872.872,0,0,1,.175.005l.262.018a3.156,3.156,0,0,1,.338.035l.331.052a6.412,6.412,0,0,1,.844.2c2.532.786,10.039,3.928,13.24,5.383,0,0,5.237-3.056,9.457,1.309,0,0,10.912-.216,8,8.183,0,0,3.929-.686,4.074,0s-4.074.693-4.074.693S472.009,550.556,470.9,551.411Z",
    transform: "translate(-426.329 -531.026)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M470.9,551.411a.766.766,0,0,1-.367.152c-2.258.425-4.8-2.992-4.941-3.189a28.181,28.181,0,0,1,1.9,13.281l-1.135,2c-.017-.186-.035-.385-.058-.588-.017-.157-.035-.32-.058-.483-.024-.193-.046-.4-.082-.6s-.058-.4-.093-.611c-.076-.437-.163-.9-.268-1.362-.035-.186-.082-.373-.128-.565,0-.011-.006-.023-.006-.029-.041-.18-.088-.36-.14-.541-.058-.215-.116-.436-.186-.663-.035-.122-.07-.25-.116-.378-.081-.279-.18-.564-.279-.85-.046-.134-.1-.274-.151-.407s-.1-.274-.157-.408-.1-.25-.151-.372a.476.476,0,0,1-.041-.1c-.111-.25-.221-.507-.349-.756-.058-.134-.128-.268-.2-.407s-.14-.274-.21-.408-.146-.268-.227-.4a14.93,14.93,0,0,0-1-1.56c-.087-.128-.18-.25-.279-.378s-.192-.25-.3-.373a.4.4,0,0,0-.035-.047q-.28-.349-.594-.681-.157-.174-.332-.349c-.343-.344-.71-.681-1.094-1-.123-.1-.251-.21-.385-.308s-.268-.2-.408-.3l-.227-.157c-.111-.081-.233-.163-.349-.238-.367-.239-.756-.466-1.158-.675-.082-.047-.163-.087-.245-.128-.192-.093-.384-.186-.582-.274-.14-.064-.285-.128-.431-.186q-.28-.123-.576-.227c-.1-.041-.21-.082-.32-.116a17.557,17.557,0,0,0-2.311-.629l-.576-.1c-.216-.035-.425-.07-.646-.1l-12.8.437-.885-.832s-9.009,3.451-11.192-4.7c-.96-3.579-.145-6.093,1.432-7.676.076-.082.157-.157.239-.233l.006-.006c.169-.145.338-.285.512-.413q.192-.139.384-.262c.116-.07.239-.146.361-.209a7.265,7.265,0,0,1,1.013-.466,8.327,8.327,0,0,1,3.126-.5.872.872,0,0,1,.175.005l.262.018a3.156,3.156,0,0,1,.338.035l.331.052c-1.432,1.8-3.672,5.494-1.275,8.754,3.318,4.516,15.981-1.135,23.035,2.345,0,0,6.372-1.368,8.078,1.647C466.311,546.645,465.06,548.391,470.9,551.411Z",
    transform: "translate(-426.329 -531.026)",
    opacity: 0.6,
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M470.9,551.411a.766.766,0,0,1-.367.152c-2.258.425-4.8-2.992-4.941-3.189a28.181,28.181,0,0,1,1.9,13.281,27.47,27.47,0,0,1-1.036,5.331,24.454,24.454,0,0,0-.1-3.335c-.017-.186-.035-.385-.058-.588-.017-.157-.035-.32-.058-.483-.024-.193-.046-.4-.082-.6s-.058-.4-.093-.611c-.076-.437-.163-.9-.268-1.362-.035-.186-.082-.378-.128-.565,0-.011-.006-.023-.006-.029-.047-.18-.088-.36-.14-.541-.058-.215-.116-.436-.186-.663-.035-.122-.076-.25-.116-.378-.081-.279-.18-.564-.279-.85-.046-.134-.1-.268-.151-.407s-.1-.274-.157-.408-.1-.25-.151-.372a.476.476,0,0,1-.041-.1c-.111-.25-.221-.507-.349-.756-.064-.14-.128-.274-.2-.407s-.14-.274-.21-.408-.146-.268-.227-.4a17.279,17.279,0,0,0-1-1.56c-.093-.128-.186-.256-.279-.378s-.2-.25-.3-.373a.4.4,0,0,0-.035-.047q-.289-.349-.594-.681l-.332-.349c-.343-.344-.71-.681-1.094-1-.128-.1-.256-.21-.385-.308s-.273-.2-.408-.3l-.227-.157c-.111-.081-.233-.163-.349-.238-.367-.239-.756-.466-1.158-.675-.082-.047-.163-.087-.245-.128-.192-.093-.384-.186-.582-.274-.14-.07-.285-.128-.431-.186q-.28-.123-.576-.227c-.1-.041-.216-.082-.32-.116a17.557,17.557,0,0,0-2.311-.629l-.576-.1c-.216-.035-.425-.07-.646-.1l-12.8.437-.885-.832s-9.009,3.451-11.192-4.7c-.96-3.579-.145-6.093,1.432-7.676.076-.082.157-.157.239-.233l.006-.006a6.023,6.023,0,0,1,.512-.413q.192-.139.384-.262c.116-.076.239-.146.361-.209a7.265,7.265,0,0,1,1.013-.466,8.327,8.327,0,0,1,3.126-.5.872.872,0,0,1,.175.005l.262.018a3.156,3.156,0,0,1,.338.035l.331.052a6.412,6.412,0,0,1,.844.2c2.532.786,10.039,3.928,13.24,5.383,0,0,5.237-3.056,9.457,1.309,0,0,10.912-.216,8,8.183,0,0,3.929-.686,4.074,0s-4.074.693-4.074.693S472.009,550.556,470.9,551.411Z",
    transform: "translate(-426.329 -531.026)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M490.754,576.044s1.3-4.237,5.374-3.461,2.716,14.258-6.014,13.386Z",
    transform: "translate(-443.538 -546.811)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M493.726,583.14a.978.978,0,0,0,.495-.354c.878-1.272,1.46-2.732,2.407-3.957a1.806,1.806,0,0,0,.479-1.188.316.316,0,0,0-.158-.268.409.409,0,0,0-.214-.026,2.532,2.532,0,0,0-1.611.923,8.025,8.025,0,0,0-1.772,3.417,2.83,2.83,0,0,0-.2,1.081.47.47,0,0,0,.173.322A.453.453,0,0,0,493.726,583.14Z",
    transform: "translate(-444.691 -548.659)",
    opacity: 0.6,
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M422.478,576.044s-1.3-4.237-5.374-3.461-2.716,14.258,6.014,13.386Z",
    transform: "translate(-414.906 -546.811)",
    fill: "url(#linear-gradient-7)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 25.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M422.478,576.044s-1.3-4.237-5.374-3.461-2.716,14.258,6.014,13.386Z",
    transform: "translate(-414.906 -572.488)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M418.455,577.027s3.049.68,4.171,5.48",
    transform: "translate(-416.257 -574.216)",
    fill: "none",
    stroke: "#591c87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M421.75,580.225a3.848,3.848,0,0,0-.722,5.488",
    transform: "translate(-416.922 -575.433)",
    fill: "none",
    stroke: "#591c87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(46.576 25.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M490.754,576.044s1.3-4.237,5.374-3.461,2.716,14.258-6.014,13.386Z",
    transform: "translate(-490.114 -572.488)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M497.261,577.027s-3.049.68-4.171,5.48",
    transform: "translate(-491.247 -574.216)",
    fill: "none",
    stroke: "#591c87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M495.578,580.225a3.848,3.848,0,0,1,.722,5.488",
    transform: "translate(-492.194 -575.433)",
    fill: "none",
    stroke: "#591c87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    d: "M20.267,0h.582A18.873,18.873,0,0,1,39.721,18.873v3.855a19.86,19.86,0,0,1-19.86,19.86h0A19.86,19.86,0,0,1,0,22.728V20.267A20.267,20.267,0,0,1,20.267,0Z",
    transform: "translate(7.485 13.189)",
    fill: "url(#linear-gradient-8)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    d: "M20.267,0h.582A18.873,18.873,0,0,1,39.721,18.873v3.855a19.86,19.86,0,0,1-19.86,19.86h0A19.86,19.86,0,0,1,0,22.728V20.267A20.267,20.267,0,0,1,20.267,0Z",
    transform: "translate(7.485 13.189)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y1: 7.252,
    x2: 5.712,
    transform: "translate(42.646 27.231)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 2.774,
    y1: 5.25,
    transform: "translate(7.572 29.233)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M471.035,567.442c.2.055.4.111.6.167.764.211,2.6,1.086,1.205,2.037-1.205.821-4.217-.345-5.41-.842a1.157,1.157,0,0,1-.529-.349.781.781,0,0,1,.18-.987,1.811,1.811,0,0,1,1.011-.381A7.459,7.459,0,0,1,471.035,567.442Z",
    transform: "translate(-434.66 -544.741)",
    fill: "#59282f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M441.321,567.472c-.2.055-.4.112-.6.167-.764.212-2.6,1.086-1.205,2.037,1.2.821,4.216-.345,5.41-.841a1.164,1.164,0,0,0,.53-.349.782.782,0,0,0-.18-.987,1.808,1.808,0,0,0-1.01-.38A7.469,7.469,0,0,0,441.321,567.472Z",
    transform: "translate(-424.08 -544.752)",
    fill: "#59282f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(11.481 33.213)"
  }, _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 1.358,
    y2: 7.303,
    transform: "translate(12.05)",
    fill: "none",
    stroke: "#591c87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 1.322,
    y2: 4.716,
    transform: "translate(18.355 1.27)",
    fill: "none",
    stroke: "#591c87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M433.445,587.526s16.338,4.208,29.875.155C463.32,587.681,452.027,599.675,433.445,587.526Z",
    transform: "translate(-433.445 -585.749)",
    opacity: 0.6,
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M463.5,586.707c-15.423,8.42-32.3,0-32.3,0,1.064,8.881-.654,12.3-.663,12.315A17.453,17.453,0,0,0,445.8,608h4.8a17.432,17.432,0,0,0,14.187-7.29C463.914,593.232,463.5,586.707,463.5,586.707Z",
    transform: "translate(-420.858 -552.224)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M464.789,604.9a17.428,17.428,0,0,1-14.183,7.287h-4.8a17.465,17.465,0,0,1-15.266-8.98,14.4,14.4,0,0,0,.984-5.406,38.612,38.612,0,0,0,32.521-.1C464.241,599.821,464.486,602.3,464.789,604.9Z",
    transform: "translate(-420.857 -556.406)",
    opacity: 0.5,
    fill: "url(#linear-gradient-11)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M463.5,586.707c-15.423,8.42-32.3,0-32.3,0,1.064,8.881-.654,12.3-.663,12.315A17.453,17.453,0,0,0,445.8,608h4.8a17.432,17.432,0,0,0,14.187-7.29C463.914,593.232,463.5,586.707,463.5,586.707Z",
    transform: "translate(-420.858 -552.224)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M439.306,600.364s11.948,4.074,23.394,0",
    transform: "translate(-424.195 -557.423)",
    fill: "none",
    stroke: "#591c87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M444.274,609.331s8.806,3,17.24,0",
    transform: "translate(-426.086 -560.837)",
    fill: "none",
    stroke: "#591c87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M455.647,553.262c-9.178-.582-20.334,1.612-24.065,11.547-3.614,9.62-.873,20.171.978,25.409a17.374,17.374,0,0,1-5.564-12.768v-7.31a17.816,17.816,0,0,1,17.815-17.82h5.314A16.523,16.523,0,0,1,455.647,553.262Z",
    transform: "translate(-419.508 -539.132)",
    opacity: 0.6,
    fill: "url(#linear-gradient-12)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M497.889,573.757c-4.557-1.379-6.978,5.68-6.978,5.68l-.1-.175.209-3.218s1.3-4.237,5.377-3.457A2.249,2.249,0,0,1,497.889,573.757Z",
    transform: "translate(-443.802 -546.812)",
    opacity: 0.6,
    fill: "url(#linear-gradient-13)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M423.129,578.995l-.262.442s-2.346-6.838-6.763-5.738a2.186,2.186,0,0,1,1.455-1.112c4.074-.78,5.378,3.457,5.378,3.457Z",
    transform: "translate(-415.362 -546.812)",
    opacity: 0.6,
    fill: "url(#linear-gradient-14)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(2.123 28.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M421.717,583.14a.976.976,0,0,1-.495-.354c-.878-1.272-1.46-2.732-2.407-3.957a1.8,1.8,0,0,1-.479-1.188.316.316,0,0,1,.158-.268.409.409,0,0,1,.214-.026,2.533,2.533,0,0,1,1.611.923,8.024,8.024,0,0,1,1.772,3.417,2.83,2.83,0,0,1,.2,1.081.47.47,0,0,1-.172.322A.453.453,0,0,1,421.717,583.14Z",
    transform: "translate(-418.334 -577.344)",
    opacity: 0.6,
    fill: "url(#linear-gradient-15)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M443.192,536.168a9.224,9.224,0,0,0-4.583-1.59,2.225,2.225,0,0,0-1.538,3.842c1.316,1.465,3.366,1.671,5.2,1.873a81.969,81.969,0,0,0,8.522.493,44.324,44.324,0,0,1,5.2.125c2.045.252,4.055,1.117,6.123,1.449,2.149.345,4.192.258,6.272,1.025.391.144-.112-1.151-.2-1.245a2.588,2.588,0,0,0-1.545-.594,14.587,14.587,0,0,1-3.9-.973c-1.875-.747-3.716-2-5.832-2.067-2.712-.089-5.275.837-7.956.084a25.786,25.786,0,0,1-4.782-1.872C443.838,536.551,443.514,536.362,443.192,536.168Z",
    transform: "translate(-423.089 -532.378)",
    opacity: 0.3,
    fill: "url(#linear-gradient-16)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(16.645 27.834)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.012,
    cy: 2.012,
    rx: 2.012,
    ry: 2.012,
    fill: "#59282f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M446.6,577.618a.782.782,0,1,1-.782-.782A.783.783,0,0,1,446.6,577.618Z",
    transform: "translate(-443.019 -576.3)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(33.402 27.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M472.865,577.983a2.012,2.012,0,1,1-2.012-2.012A2.012,2.012,0,0,1,472.865,577.983Z",
    transform: "translate(-468.841 -575.971)",
    fill: "#59282f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M473.695,577.618a.782.782,0,1,1-.782-.782A.782.782,0,0,1,473.695,577.618Z",
    transform: "translate(-470.094 -576.3)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.af345185030ad9f061689b11c584cb4b.svg";
export { ForwardRef as ReactComponent };